import { combineReducers } from 'redux';

import dataSet from './dataSet';
import bootstrapCIs from './bootstrapCIs';
import distributions from './distributions';
import graphicalStatistics from './graphicalStatistics';
import randomizationHypothesisTesting from './randomizationHypothesisTesting';
import inferentialStatistics from './inferentialStatistics';

export default combineReducers({
  randomizationHypothesisTesting,
  inferentialStatistics,
  graphicalStatistics,
  distributions,
  bootstrapCIs,
  dataSet
});
